import { matchesRegisterSearch, normalizeRegisterSearch } from "./registerWordListDisplay";

export const GROUPINGS_SELECTION_LS_KEY = "vocabularium_groupings_selection";
export const GROUPINGS_SCROLL_LS_KEY = "vocabularium_groupings_scroll";
export const GROUPINGS_SEARCH_SCOPE_LS_KEY = "vocabularium_groupings_search_scope";

export const GROUPINGS_SEARCH_SCOPES = {
  WORD: "word",
  GROUPING: "grouping",
};

export const GROUPINGS_SEARCH_SCOPE_OPTIONS = [
  {
    id: GROUPINGS_SEARCH_SCOPES.WORD,
    letter: "M",
    tooltip: "Rechercher par mot",
  },
  {
    id: GROUPINGS_SEARCH_SCOPES.GROUPING,
    letter: "R",
    tooltip: "Rechercher par groupement",
  },
];

export function sanitizeGroupingsSearchScope(raw) {
  const value = String(raw || "").trim();
  return value === GROUPINGS_SEARCH_SCOPES.WORD
    ? GROUPINGS_SEARCH_SCOPES.WORD
    : GROUPINGS_SEARCH_SCOPES.GROUPING;
}

export function readGroupingsSearchScope() {
  try {
    return sanitizeGroupingsSearchScope(
      localStorage.getItem(GROUPINGS_SEARCH_SCOPE_LS_KEY)
    );
  } catch {
    return GROUPINGS_SEARCH_SCOPES.GROUPING;
  }
}

export function writeGroupingsSearchScope(scope = GROUPINGS_SEARCH_SCOPES.GROUPING) {
  const value = sanitizeGroupingsSearchScope(scope);
  try {
    localStorage.setItem(GROUPINGS_SEARCH_SCOPE_LS_KEY, value);
  } catch {
    // quota / mode privé : on ignore
  }
  return value;
}

export function groupingIdsMatchingWordQuery(affiliations, query, searchMode) {
  const normalizedQuery = normalizeRegisterSearch(query);
  if (!normalizedQuery) return null;
  const ids = new Set();
  for (const item of Array.isArray(affiliations) ? affiliations : []) {
    if (matchesRegisterSearch(item, normalizedQuery, searchMode)) {
      const id = String(item?.groupementId || "").trim();
      if (id) ids.add(id);
    }
  }
  return ids;
}

export function resolveGroupingIdFromWordQuery(affiliations, query, searchMode) {
  const normalizedQuery = normalizeRegisterSearch(query);
  if (!normalizedQuery) return null;
  const matched = (Array.isArray(affiliations) ? affiliations : []).filter((item) =>
    matchesRegisterSearch(item, normalizedQuery, searchMode)
  );
  if (!matched.length) return null;

  const exact = matched.filter(
    (item) => normalizeRegisterSearch(item.mot) === normalizedQuery
  );
  const pool = exact.length ? exact : matched;
  const ids = [];
  const seen = new Set();
  for (const item of pool) {
    const id = String(item?.groupementId || "").trim();
    if (!id || seen.has(id)) continue;
    seen.add(id);
    ids.push(id);
  }
  return ids.length === 1 ? ids[0] : null;
}

function readMap(key) {
  try {
    const raw = localStorage.getItem(key);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

function writeMap(key, map) {
  try {
    localStorage.setItem(key, JSON.stringify(map && typeof map === "object" ? map : {}));
  } catch {
    // quota / mode privé : on ignore
  }
}

export function readGroupingsSelection() {
  try {
    const value = localStorage.getItem(GROUPINGS_SELECTION_LS_KEY);
    return typeof value === "string" && value.trim() ? value.trim() : null;
  } catch {
    return null;
  }
}

export function writeGroupingsSelection(groupementId) {
  const value = String(groupementId || "").trim();
  try {
    if (value) {
      localStorage.setItem(GROUPINGS_SELECTION_LS_KEY, value);
    } else {
      localStorage.removeItem(GROUPINGS_SELECTION_LS_KEY);
    }
  } catch {
    // quota / mode privé : on ignore
  }
  return value || null;
}

export function readGroupingsScrollMap() {
  return readMap(GROUPINGS_SCROLL_LS_KEY);
}

export function writeGroupingsScrollMap(map) {
  writeMap(GROUPINGS_SCROLL_LS_KEY, map);
}

export function getGroupingsScrollStorageKey(searchQuery = "", searchMode = "") {
  const query = String(searchQuery || "").trim().toLowerCase();
  const mode = String(searchMode || "starts_with");
  return `${mode}:${query}`;
}
